// sleep function using promise
export function sleep(time = 1000) {
	return new Promise(resolve => {
		setTimeout(resolve, time);
	});
}

export default sleep;
